import { CreditCard } from 'lucide-react';

export default function NHCIdBadge({ nhcId, size = 'md' }: { nhcId: string; size?: 'sm' | 'md' }) {
  return (
    <span className={`inline-flex items-center gap-1.5 rounded-lg bg-teal-50 border border-teal-200 text-teal-700 font-mono font-semibold ${
      size === 'sm' ? 'text-[10px] px-2 py-0.5' : 'text-xs px-2.5 py-1'
    }`}>
      <CreditCard className={size === 'sm' ? 'w-3 h-3' : 'w-3.5 h-3.5'} />
      {nhcId}
    </span>
  );
}
